/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import React, { Component } from 'react'
import {connect} from 'react-redux'

import './Toaster.css'

class ToasterComponent extends Component {

    constructor() {
        super()
        this.state = {step: 'start'}
        this.timeouts = []
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.message !== nextProps.message) {
            while (this.timeouts.length > 0) {
                let to = this.timeouts.pop()
                clearTimeout(to)
            }
            this.setState({ step: 'start' })

            
        }
    }

    componentDidUpdate() {
        if (this.props.message.length > 0 && this.state.step === 'start') {
            let t1 = setTimeout(() => { this.setState({step: 'in'}) }, 30)
            let t2 = setTimeout(() => { this.setState({step: 'out'}) }, 2000)
            let t3 = setTimeout(() => { this.props.toast('') }, 2600)
            let t4 = setTimeout(() => { this.setState({step: 'start'}) }, 2700)
            this.timeouts.push(t1)
            this.timeouts.push(t2)
            this.timeouts.push(t3)
            this.timeouts.push(t4)
        }
    }


    render() {
        var klass = 'toast'
        if (this.state.step === 'in') { klass += ' in' }
        else if (this.state.step === 'out') { klass += ' out' }

        return(
            <div className={klass}>
                <div className="toast-message">{this.props.message}</div>
            </div>
        )
    }

}

const mapStateToProps = (state, props) => {
    var message = state.toast
    return {
        message,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toast: (message) => {
            dispatch({
                type: "TOAST",
                message: message
            })
        }
    }
}

const Toaster = connect(mapStateToProps, mapDispatchToProps)(ToasterComponent)

export default Toaster
